module.exports = __webpack_public_path__ + "static/img/tab2.345c922.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/tab2.png
// module id = CWd2
// module chunks = 1